webpackJsonp([49],{

/***/ "2byv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TemplateLandingPages_1 = __webpack_require__("9/76");
var SuccessStoriesList = (function () {
    function SuccessStoriesList() {
        this.storiesList = TemplateLandingPages_1.default
            .filter(function (template) { return template.url.match(/\/success-stories\//); })
            .map(function (story) {
            var companyInfoData = _.first(story.sections);
            return {
                url: story.url,
                bgImage: companyInfoData.background.imageUrl,
                logo: companyInfoData.logoUrl,
                description: companyInfoData.title
            };
        });
    }
    return SuccessStoriesList;
}());
angular.module('animatronApp.successStoriesList', []).component('successStoriesList', {
    controller: SuccessStoriesList,
    templateUrl: __webpack_require__("jKm6")
});


/***/ }),

/***/ "jKm6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/success-stories-list_67e27b139a5e5af19e8d8ff3b12da19a.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/49-28dc41a6a889e793a2e2.min.js